import React, { useRef, useEffect } from "react";
import gsap from "gsap";
import Work from "../Components/Work";
import { personalDetails, workDetails, eduDetails } from "../Details";

function About() {
  
  const about = useRef();
  const work = useRef();
  const edu = useRef();
  
  useEffect(() => {
    const tl = gsap.timeline();
    
    tl.from(
      about.current,//from top
      {
        y: "-100%",
        delay: 0.2,
        opacity: 0,
        duration: 1,
        ease: "Power3.easeOut",
      },
      "<"
    )
      .from(
        work.current,
        {
          x: "-100%",//from left
          delay: 0.2,
          opacity: 0,
          duration: 1,
          ease: "Power3.easeOut",
        },
        "<"
      )
      .from(
        edu.current,
        {
          x: "200%",//from right
          delay: 0.2,
          opacity: 0,
          duration: 1,
          ease: "Power3.easeOut",
        },
        "<"
      );
  }, []);
  return (
    <main className="container mx-auto max-width pt-10 pb-20 ">
      <section ref={about}>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Tentang Saya
        </h1>
        <p className="text-content py-8 lg:max-w-3xl">{personalDetails.about}</p>
      </section>
      <section ref={work}>
        <h1 className="text-2xl text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Pengalaman Kerja
        </h1>
        {React.Children.toArray(
          workDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work
              position={Position}
              company={Company}
              location={Location}
              type={Type}
              duration={Duration}
            />
          ))
        )}
      </section>
      <section ref={edu}>
        <h1 className="text-2xl pt-10 text-dark-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold">
          Pendidikan
        </h1>
        {React.Children.toArray(
          eduDetails.map(({ Position, Company, Location, Type, Duration }) => (
            <Work
              position={Position}
              company={Company}
              location={Location}
              type={Type}
              duration={Duration}
            />
          ))
        )}
      </section>
    </main>
  );
}

export default About;
